let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8qZuf")).then(() => parcelRequire('eNfxD'));